import React from "react";
import { useOutletContext } from "react-router-dom";
import { formatDate, formatToZMW, rootUrl } from "../helpers";

const Receipt = React.forwardRef(({data}, ref) => {

    const allData = useOutletContext();

    const {cheque,
        date,
        paye,
        amount,
        paymentMethod="Bank",
        description,
        updatedBy,
        receivedBy = {},
        issuedBy = {},
        bankDetails = {
          bankName: "",
          accountNo: "",
        }} = data

         const user = allData.users?.find(a=>a.uid == updatedBy)
      const preparer = `${user?.firstName} ${user?.lastName}`

         data.issuedBy = {
                name:preparer,
                signature:'...............',
                date:formatDate(date)
              }

  return (
    <div ref={ref} className="border border-gray-500 p-4 w-[800px] mx-auto rounded-lg">
      <div className="flex justify-between items-center"> 
            <img src="arms.png" className="w-36" alt="" />
            <h2 className="text-lg font-semibold text-center">MINISTRY OF LOCAL GOVERNMENT AND RURAL DEVELOPMENT
              <br />
              {allData?.council[0]?.name}
            </h2>
            <img src={rootUrl(`/${allData?.council[0]?.path}`)} alt="" />
            </div>
      <h2 className="text-lg font-semibold text-center">RECEIPT</h2>
      <div className="flex justify-between items-start mb-4">
        <div>
          <p>RECEIPT NO.: {cheque}</p>
          <p>DATE: {formatDate(date)}</p>
        </div>
      </div>

      {/* Payee and Payment Method */}
      <div className="mb-4">
        <p>
          <span className="font-semibold">PAYEE:</span> {allData.customer?.find(a=>a.id === paye)?.firstname} {" "} {allData.customer?.find(a=>a.id === paye)?.lastname}
        </p>
        <p>
          <span className="font-semibold">PAYMENT METHOD:</span> {paymentMethod}
        </p>
      </div>

      {/* Description of Payment */}
      <div className="mb-4">
        <p className="font-semibold">DESCRIPTION OF PAYMENT:</p>
        <p className="h-12 border border-gray-300 p-2">
          {description}
        </p>
      </div>

      {/* Amount in Words */}
      <div className="mb-4">
        <p className="font-semibold">AMOUNT:</p>
        <p className="h-8 border border-gray-300 p-2">{formatToZMW(amount)}</p>
      </div>

      {/* Bank Details */}
      {bankDetails.bankName && (
        <div className="mb-4">
          <p>
            <span className="font-semibold">BANK NAME:</span>{" "}
            {bankDetails.bankName}
          </p>
          <p>
            <span className="font-semibold">ACCOUNT NO:</span>{" "}
            {bankDetails.accountNo}
          </p>
        </div>
      )}

      {/* Signatures */}
      <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
        {/* Received By */}
        <div className="border p-2">
          <p className="font-semibold">RECEIVED BY</p>
          <p>Name: {receivedBy.name}</p>
          <p>Signature: {receivedBy.signature}</p>
          <p>Date: {receivedBy.date}</p>
        </div>

        {/* Issued By */}
        <div className="border p-2">
          <p className="font-semibold">ISSUED BY</p>
          <p>Name: {issuedBy.name}</p>
          <p>Signature: {issuedBy.signature}</p>
          <p>Date: {issuedBy.date}</p>
        </div>
      </div>

      {/* Footer Note */}
      <p className="text-xs mt-4">
        NOTE: This is an official receipt. Please retain it for your records.
      </p>
    </div>
  );
});

export default Receipt;
